const NON_ACTIVE_USER_FILTER: string = "terms";
const ONLINE_USER_FILTER: string = "onlineStatus";
const MOBILE_USER_FILTER: string = "device";

export { NON_ACTIVE_USER_FILTER, ONLINE_USER_FILTER, MOBILE_USER_FILTER };
